// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"618":"c32eddb2","673":"31d6cfe0","797":"2571d4d8"}[chunkId] + ".chunk.css";
};